import { forwardRef } from 'react';

import {
  RangePicker as SharedRangePicker,
  type RangePickerProps as SharedRangePickerProps,
  type RangePickerRef,
} from '@cast/shared-date-ui';

import { useIsClusterDemoMode } from '@cast/infrastructure-demo';

export type RangePickerProps = SharedRangePickerProps;
export type { RangePickerRef };

export const RangePicker = forwardRef<RangePickerRef, RangePickerProps>(
  (props, ref) => {
    const isClusterDemoMode = useIsClusterDemoMode();

    return (
      <SharedRangePicker
        ref={ref}
        {...props}
        hideTimezonePicker={isClusterDemoMode}
      />
    );
  }
);

RangePicker.displayName = 'RangePicker';
